module.exports = __webpack_public_path__ + "images/6534be8d.png";